const commodityList = [
  {
    bgc: require("@/assets/image/36.png")
  },
    {
    bgc: require("@/assets/image/37.png")
  },
  {
    // title: "当季女装",
    // des: "潮流尖货时尚新款",
    bgc: require("@/assets/image/03.png")
  },
  {
    // title: "品牌男装",
    // des: "高端品味限时特优",
    bgc: require("@/assets/image/04.png")
  },
  {
    // title: "美妆护肤",
    // des: "各款大牌缤纷满减",
    bgc: require("@/assets/image/05.png")
  },
  {
    // title: "环球美食",
    // des: "美食荟萃随心享",
    bgc: require("@/assets/image/06.png")
  },
  {
    // title: "家电数码",
    // des: "尽享数码智能生活",
    bgc: require("@/assets/image/07.png")
  },
  {
    // title: "鞋包配饰",
    // des: "四季爆款实惠到家",
    bgc: require("@/assets/image/08.png")
  },
  {
    // title: "母婴呵护",
    // des: "超值大牌正品保障",
    bgc: require("@/assets/image/09.png")
  },
  {
    // title: "家纺家具",
    // des: "舒心生活随心选",
    bgc: require("@/assets/image/10.png")
  },
  {
    // title: "运动户外",
    // des: "大牌汇聚运动之乐",
    bgc: require("@/assets/image/11.png")
  },
  {
    // title: "家居百货",
    // des: "精选百货超低价",
    bgc: require("@/assets/image/12.png")
  },
  {
    // title: "海淘精选",
    // des: "全球直采品质保障",
    bgc: require("@/assets/image/13.png")
  },
]

export {
  commodityList,
};